import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { PipelinePlannedPlantationService } from '../proxy/operational/controllers/pipeline-planned-plantation.service';
import { PlantService, PlantTypeService, SpeciesGroupService } from 'cbd-proxies';

FieldBuilder.setNamespace('Operational');

export const PIPELINEPLANNEDPLANTATIONPLANT_FIELDS: FieldDefinition[] = [
  FieldBuilder.foreignKey(
    'pipelinePlannedPlantationId',
    'Entity.PipelinePlannedPlantationPlant.PipelinePlannedPlantation',
    PipelinePlannedPlantationService
  )
    .required()
    .display('id')
    .displayFromNested('pipelinePlannedPlantationId')
    .sortBy('pipelinePlannedPlantationId')
    .hideInChildForms()
    .build(),
  FieldBuilder.foreignKey(
    'plantId',
    'Entity.Plant',
    PlantService
  )
    .display('consumable.name')
    .displayFromNested('plantName')
    .sortBy('plantName')
    .loadWith((service, query, config) => {
      if (Array.isArray(query.id) && query.id.length) {
        return service.getListByIds({ ids: query.id.map(Number) }, config);
      }
      return service.getList({
        skipCount: query.skipCount,
        maxResultCount: query.maxResultCount,
        sorting: query.sorting,
        consumableName: query['consumable.name'],
      }, config);
    })
    .keyField('id')
    .build(),
  FieldBuilder.foreignKey(
    'plantTypeId',
    'Entity.PlantType',
    PlantTypeService
  )
    .display('name')
    .keyField('id')
    .build(),
  FieldBuilder.foreignKey(
    'speciesGroupId',
    'Entity.SpeciesGroup',
    SpeciesGroupService
  )
    .required()
    .display('name')
    .keyField('id')
    .build(),
];

export const PIPELINEPLANNEDPLANTATIONPLANT_CONFIG = {
  entityName: 'PipelinePlannedPlantationPlant',
  localizationKey: 'Operational::Entity.PipelinePlannedPlantationPlant',
  fields: PIPELINEPLANNEDPLANTATIONPLANT_FIELDS,
  permission: 'PlanningOperation.PipelinePlannedPlantationPlants',
  showInMenu: false,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.PlanningOperational + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Silviculture + MENU_NAME_SUFFIX,
};
